import { default as indexDDR5XEGcwbMeta } from "/builds/david.s/LocalinoHubItemSpotter/src/pages/auth/index.vue?macro=true";
import { default as historyNST74b0Q9uMeta } from "/builds/david.s/LocalinoHubItemSpotter/src/pages/history.vue?macro=true";
import { default as indexfXl6zeZRLGMeta } from "/builds/david.s/LocalinoHubItemSpotter/src/pages/index.vue?macro=true";
import { default as scannbUqt9wHZ2Meta } from "/builds/david.s/LocalinoHubItemSpotter/src/pages/scan.vue?macro=true";
import { default as settingsDfrsJ0riejMeta } from "/builds/david.s/LocalinoHubItemSpotter/src/pages/settings.vue?macro=true";
export default [
  {
    name: "auth",
    path: "/auth",
    meta: indexDDR5XEGcwbMeta || {},
    component: () => import("/builds/david.s/LocalinoHubItemSpotter/src/pages/auth/index.vue")
  },
  {
    name: "history",
    path: "/history",
    component: () => import("/builds/david.s/LocalinoHubItemSpotter/src/pages/history.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/builds/david.s/LocalinoHubItemSpotter/src/pages/index.vue")
  },
  {
    name: "scan",
    path: "/scan",
    meta: scannbUqt9wHZ2Meta || {},
    component: () => import("/builds/david.s/LocalinoHubItemSpotter/src/pages/scan.vue")
  },
  {
    name: "settings",
    path: "/settings",
    component: () => import("/builds/david.s/LocalinoHubItemSpotter/src/pages/settings.vue")
  }
]